import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { useGetAllFlags } from '@zurich/common/featureFlags';
import { featureFlagsAtom } from '@zurich/common/recoil';
export const FeatureFlagWrapper = ({ children }) => {
    const flags = useGetAllFlags();
    const setFeatureFlags = useSetRecoilState(featureFlagsAtom);
    useEffect(() => {
        setFeatureFlags(flags);
    }, [flags, setFeatureFlags]);
    return children;
};
